import React, { useState } from 'react';
import client from 'utils/client';
import { formatCurrency } from 'utils/helpers';

function BulkSettleDialog({ transactions, onClose, onComplete }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const totalAmount = transactions.reduce((sum, t) => sum + parseFloat(t.amount || 0), 0);

  const handleSettle = async () => {
    setLoading(true);
    setError(null);
    try {
      await client.post('/transactions/bulk-settle', {
        transactionIds: transactions.map((t) => t.id),
      });
      onComplete();
    } catch (err) {
      setError(err.message || 'Failed to queue settlement');
      setLoading(false);
    }
  };

  return (
    <div className='bulk-settle-overlay' onClick={onClose}>
      <div className='bulk-settle-dialog' onClick={(e) => e.stopPropagation()}>
        <div className='bulk-settle-header'>
          <h3 style={{ margin: 0 }}>Retry Settlement</h3>
          <button type='button' className='bulk-settle-close' onClick={onClose}>&times;</button>
        </div>
        <div className='bulk-settle-body'>
          <p style={{ margin: '0 0 12px' }}>
            You are about to retry settlement for <strong>{transactions.length}</strong> unsettled
            transaction{transactions.length !== 1 ? 's' : ''} with a total value
            of <strong>{formatCurrency(totalAmount)}</strong>.
          </p>
          <p className='bulk-settle-note'>
            Today&apos;s transactions are included only for Instant terminals. For EOD terminals they
            are excluded, because end-of-day settlement will still pick them up tonight.
          </p>
          {error && <p style={{ color: 'var(--color-danger)', marginTop: 12, marginBottom: 0 }}>{error}</p>}
        </div>
        <div className='bulk-settle-actions'>
          <button type='button' className='btn-secondary' onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button type='button' className='btn-primary' onClick={handleSettle} disabled={loading}>
            {loading ? 'Submitting...' : `Settle ${transactions.length} Transaction${transactions.length !== 1 ? 's' : ''}`}
          </button>
        </div>
      </div>
    </div>
  );
}

export default BulkSettleDialog;
